import { sfg20DateFormat } from "lib/sfg20-date-format"
import { assetAndTaskDateFields } from "./assetAndTaskDateFields"

export function formatDatesInAssetOrTask(assetOrTask, format) {
    for (const field in assetOrTask) {
        if (assetAndTaskDateFields.includes(field)) {
            const value = assetOrTask[field]
            if (!value || value === new Date(0)) {
                continue
            }
            try {
                assetOrTask[field] = sfg20DateFormat(value, format)
            } catch (e) {
                assetOrTask[field] = String(value)
            }
        }
    }
}
